export const AJAX_URL = '/ui_api';
